/**
 * anchorNav — detail-page anchor nav dropdown enhancement (Alpine CSP build).
 *
 * The mobile anchor nav is a native <details>/<summary>, so it opens and
 * the in-page anchor links work with no JS at all. This sprinkle closes
 * the dropdown when a link is chosen (the panel sits on a sticky bar and
 * would otherwise stay open over the content the user just jumped to),
 * on outside click, and on Escape — wired via x-on in the partial.
 */
export default function anchorNav() {
    return {
        closeMenu() {
            this.$root.removeAttribute('open');
        },
    };
}
